export const quotaionMockData = {
    Me_and_My_Direct_Family: {
        10000: [
            {
                minAge: 18,
                maxAge: 25,
                premium: 79.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 88.5,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 106.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 144.5,
            },
            {
                minAge: 56,
                maxAge: 100,
                premium: 193.0,
            },
        ],
        20000: [
            {
                minAge: 18,
                maxAge: 25,
                premium: 98.5,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 118.5,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 154.5,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 231.5,
            },
            {
                minAge: 56,
                maxAge: 100,
                premium: 328.0,
            },
        ],
        30000: [
            {
                minAge: 18,
                maxAge: 25,
                premium: 117.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 148.5,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 202.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 318.0,
            },
            {
                minAge: 56,
                maxAge: 100,
                premium: 464.5,
            },
        ],
        40000: [
            {
                minAge: 18,
                maxAge: 25,
                premium: 136.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 178.0,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 249.5,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 404.5,
            },
            {
                minAge: 56,
                maxAge: 100,
                premium: 600.0,
            },
        ],
        50000: [
            {
                minAge: 18,
                maxAge: 25,
                premium: 154.5,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 207.5,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 297.5,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 493.0,
            },
            {
                minAge: 56,
                maxAge: 100,
                premium: 735.0,
            },
        ],
        60000: [
            {
                minAge: 18,
                maxAge: 25,
                premium: 174.5,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 237.0,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 346.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 579.5,
            },
            {
                minAge: 56,
                maxAge: 100,
                premium: 872.0,
            },
        ],
    },
    Myself: {
        10000: [
            {
                minAge: 18,
                maxAge: 25,
                premium: 32.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 42.0,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 49.5,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 60.5,
            },
            {
                minAge: 56,
                maxAge: 100,
                premium: 80.0,
            },
        ],
        20000: [
            {
                minAge: 18,
                maxAge: 25,
                premium: 43.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 64.0,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 79.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 102.0,
            },
            {
                minAge: 56,
                maxAge: 100,
                premium: 141.0,
            },
        ],
        30000: [
            {
                minAge: 18,
                maxAge: 25,
                premium: 54.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 85.5,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 109.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 143.0,
            },
            {
                minAge: 56,
                maxAge: 100,
                premium: 203.5,
            },
        ],
        40000: [
            {
                minAge: 18,
                maxAge: 25,
                premium: 65.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 107.5,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 138.5,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 184.5,
            },
            {
                minAge: 56,
                maxAge: 100,
                premium: 264.5,
            },
        ],
        50000: [
            {
                minAge: 18,
                maxAge: 25,
                premium: 76.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 129.0,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 167.5,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 225.0,
            },
            {
                minAge: 56,
                maxAge: 100,
                premium: 325.0,
            },
        ],
        60000: [
            {
                minAge: 18,
                maxAge: 25,
                premium: 87.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 150.0,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 197.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 267.5,
            },
            {
                minAge: 56,
                maxAge: 100,
                premium: 387.5,
            },
        ],
    },
    My_Extended_Family: {
        5000: [
            {
                minAge: 0,
                maxAge: 15,
                premium: 10.0,
            },

            {
                minAge: 16,
                maxAge: 25,
                premium: 22.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 24.0,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 34.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 38.0,
            },
            {
                minAge: 56,
                maxAge: 65,
                premium: 46.0,
            },
            {
                minAge: 66,
                maxAge: 75,
                premium: 68.0,
            },
        ],
        10000: [
            {
                minAge: 0,
                maxAge: 15,
                premium: 12.0,
            },
            {
                minAge: 16,
                maxAge: 25,
                premium: 27.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 34.0,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 46.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 58.0,
            },
            {
                minAge: 56,
                maxAge: 65,
                premium: 80.0,
            },
            {
                minAge: 66,
                maxAge: 75,
                premium: 125.0,
            },
        ],
        15000: [
            {
                minAge: 0,
                maxAge: 15,
                premium: 14.0,
            },
            {
                minAge: 16,
                maxAge: 25,
                premium: 42.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 48.0,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 54.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 68.0,
            },
            {
                minAge: 56,
                maxAge: 65,
                premium: 95.5,
            },
            {
                minAge: 66,
                maxAge: 75,
                premium: 164.0,
            },
        ],
        20000: [
            {
                minAge: 0,
                maxAge: 15,
                premium: 15.0,
            },
            {
                minAge: 16,
                maxAge: 25,
                premium: 49.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 57.0,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 66.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 87.0,
            },
            {
                minAge: 56,
                maxAge: 65,
                premium: 124.5,
            },
            {
                minAge: 66,
                maxAge: 75,
                premium: 216.0,
            },
        ],
        25000: [
            {
                minAge: 0,
                maxAge: 15,
                premium: 18.0,
            },
            {
                minAge: 16,
                maxAge: 25,
                premium: 54.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 61.0,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 71.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 96.0,
            },
            {
                minAge: 56,
                maxAge: 65,
                premium: 153.5,
            },
            {
                minAge: 66,
                maxAge: 75,
                premium: 268.0,
            },
        ],
        30000: [
            {
                minAge: 0,
                maxAge: 15,
                premium: 19.0,
            },
            {
                minAge: 16,
                maxAge: 25,
                premium: 59.0,
            },
            {
                minAge: 26,
                maxAge: 35,
                premium: 67.0,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 78.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 113.5,
            },
            {
                minAge: 56,
                maxAge: 65,
                premium: 182.0,
            },
            {
                minAge: 66,
                maxAge: 75,
                premium: 319.5,
            },
        ],
    },
    My_Parents_and_In_laws: {
        5000: [
            {
                minAge: 18,
                maxAge: 35,
                premium: 17.5,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 21.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 26.5,
            },
            {
                minAge: 56,
                maxAge: 65,
                premium: 37.5,
            },
            {
                minAge: 66,
                maxAge: 75,
                premium: 60.5,
            },
        ],
        10000: [
            {
                minAge: 18,
                maxAge: 35,
                premium: 25.5,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 32.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 44.0,
            },
            {
                minAge: 56,
                maxAge: 65,
                premium: 66.5,
            },
            {
                minAge: 66,
                maxAge: 75,
                premium: 112.0,
            },
        ],
        15000: [
            {
                minAge: 18,
                maxAge: 35,
                premium: 33.5,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 43.5,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 61.0,
            },
            {
                minAge: 56,
                maxAge: 65,
                premium: 95.5,
            },
            {
                minAge: 66,
                maxAge: 75,
                premium: 164.0,
            },
        ],
        20000: [
            {
                minAge: 18,
                maxAge: 35,
                premium: 41.5,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 55.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 78.5,
            },
            {
                minAge: 56,
                maxAge: 65,
                premium: 124.0,
            },
            {
                minAge: 66,
                maxAge: 75,
                premium: 216.0,
            },
        ],
        25000: [
            {
                minAge: 18,
                maxAge: 35,
                premium: 49.5,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 66.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 96.0,
            },
            {
                minAge: 56,
                maxAge: 65,
                premium: 153.0,
            },
            {
                minAge: 66,
                maxAge: 75,
                premium: 267.0,
            },
        ],
        30000: [
            {
                minAge: 18,
                maxAge: 35,
                premium: 57.0,
            },
            {
                minAge: 36,
                maxAge: 45,
                premium: 78.0,
            },
            {
                minAge: 46,
                maxAge: 55,
                premium: 113.5,
            },
            {
                minAge: 56,
                maxAge: 65,
                premium: 182.0,
            },
            {
                minAge: 66,
                maxAge: 75,
                premium: 319.5,
            },
        ],
    },
};

export const paidUpMock = [
    {
        minAge: 18,
        maxAge: 25,
        charge: 7.5,
    },
    {
        minAge: 26,
        maxAge: 35,
        charge: 15,
    },
    {
        minAge: 36,
        maxAge: 50,
        charge: 35,
    },
];
